/**
 * The availability inputs `buildTutorials` gates `requires` on.
 *
 * Shared by all three surfaces that build the checklist — the app-wide
 * LearnMedsender panel, the Guide's Interactive Tutorials page, and the Guide
 * rail's launcher. They each used to inline their own context object, and they had
 * already drifted: two passed a bare `hasRecords: true` while resolving the user
 * identity three different ways. A tutorial the panel offers and the Guide hides
 * (or vice versa) is a bug that only shows up on one screen, so the context is
 * computed in one place.
 */

/**
 * `hasRecords` is deliberately optimistic — a tutorial is never pre-locked for
 * "you have no records".
 *
 * It was once `RECORD_LIST_PATHS.includes(currentPath) && (uploadedCount +
 * receivedCount) > 0`, which was wrong in BOTH directions. Falsely LOCKED: the
 * counts come from `state.records.uploaded_data`/`received_data`, which start `[]`
 * and are only filled once a request resolves, and nothing in that state
 * distinguishes "none exist" from "not fetched yet" — so a still-loading list, or a
 * filter matching nothing, disabled six of seven tutorials for an org that plainly
 * had records. Falsely AVAILABLE: `state.appState.currentPath` is absent from
 * `applicationState`'s initial state and is only written by containers/App's
 * `history.listen`, which never fires for the initial load, so on any hard load it
 * was `undefined` and every tutorial reported itself available regardless.
 *
 * Restoring a real pre-lock here needs a "this list has been fetched" flag in the
 * records reducer, which does not exist. The DOM check at start time covers it
 * instead, at the moment it actually matters.
 */
export const tutorialAvailabilityContext = () => ({
  hasRecords: true,
});

export default tutorialAvailabilityContext;
